import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import '../styles/common.css';

const VendorConfirm = ({ userId, companyName, fullName, managementAddress }) => {
  const { state } = useLocation();
  const navigate = useNavigate();

  const fields = [
    ['プラン', state.Plan],
    ['弊社見積No.', state.QuoteNo],
    ['発注番号', state.OrderID],
    ['法人 / 個人', state.Type],
    ['エンドユーザー会社名', state.CompanyName],
    ['エンドユーザー担当者名', state.BuyerName],
    ['エンドユーザー担当メールアドレス', state.BuyerEmail],
    ['ライセンス付与メールアドレス', state.LicenseEmail],
    ['製品名', state.ProductName],
    ['ライセンス数', state.LicenseCount],
    ['ライセンス開始日', state.StartDate],
    ['ライセンス終了日', state.EndDate]
  ];

  const handleSubmit = async () => {

    const payload = {
      CustomerEmail: state.LicenseEmail,

      A1_ProductName: state.ProductName,
      A2_LicenseCount: state.LicenseCount,
      A3_LicenseStartDate: state.StartDate,
      A4_LicenseEndDate: state.EndDate,
      A5_AuthHistory: [],

      B1_CustomerType: state.Type,
      B2_CustomerCompany: state.CompanyName,
      B3_CustomerPerson: state.BuyerName,
      B4_CustomerEmail: state.BuyerEmail,

      C1_OrderCompany: companyName,
      C2_OrderPerson: fullName,
      C3_OrderEmail: userId,
      C4_OrderNumber: state.QuoteNo,
      C5_ManagementAddress: managementAddress,
      C6_OrderID: state.OrderID,

      D3_Trial: state.Plan
    };

    try {
      const res = await fetch('https://ocuauez4ka.execute-api.ap-northeast-1.amazonaws.com/RegisterStage/register_license', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload)
      });

      const data = await res.json();
      if (data.message === "success") {
        navigate('/license/success');
      } else {
        alert('送信に失敗しました');
      }
    } catch (err) {
      console.error('送信エラー:', err);
      alert('サーバーエラーが発生しました');
    }
  };

  return (
    <div className="container">
      <h1 className="title">申請内容の確認</h1>
      <table className="confirm-table">
        <tbody>
          {fields.map(([label, value], idx) => (
            <tr key={idx} className={idx % 2 === 0 ? 'even-row' : 'odd-row'}>
              <td className="label-cell">{label}</td>
              <td>{value || '（未入力）'}</td>
            </tr>
          ))}
        </tbody>
      </table>

      <div className="button-group">
        <button
          className="button button-gray button-fixed"
          onClick={() => navigate('/license/new-request', { state })}
        >
          修正
        </button>
        <button className="button button-purple button-fixed" onClick={handleSubmit}>申請</button>
      </div>
    </div>
  );
};

export default VendorConfirm;
